'use client'

import { FC } from 'react'

interface PriceSliderThumbProps {
	filterId: string
}

const PriceSliderThumb: FC<PriceSliderThumbProps> = ({ filterId }) => {
	return (
		<svg
			className="price-slider__thumb relative cursor-pointer outline-none"
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ overflow: 'visible' }}
		>
			<defs>
				<filter
					id={filterId}
					x="-30"
					y="-30"
					width="92"
					height="92"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="6" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.08 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_265_97272"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="15" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_265_97272"
						result="effect2_dropShadow_265_97272"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_265_97272"
						result="shape"
					/>
				</filter>
			</defs>
			<g filter={`url(#${filterId})`}>
				<circle cx="16" cy="16" r="16" fill="#1E293B" />
				<circle cx="16" cy="16" r="12" stroke="white" strokeWidth="8" />
			</g>
		</svg>
	)
}

export default PriceSliderThumb

